import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { AuthenticationService } from '@treasury/domain/services/authentication';
import { TmBaseComponent } from '@treasury/presentation';
import { css, html, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import './login-container';
import './login-error';

export const tagName = 'uis-container';
@customElement(tagName)
export class UisContainer extends TmBaseComponent {
    @InjectProperty()
    declare private authService: AuthenticationService;

    @state()
    private isUisEnabled = true;

    @state()
    private uisFailure = false;

    protected async firstUpdated(): Promise<void> {
        try {
            const resp = await this.authService.uisForcedMetadataPromise;
            if (!resp) {
                throw new Error('Error getting UIS metadata');
            }
            const { isUisEnabled, uisLoginUrl } = resp;
            this.isUisEnabled = isUisEnabled;
            if (isUisEnabled && uisLoginUrl) {
                window.location.href = uisLoginUrl;
            }
        } catch (e) {
            this.logger.logError(
                'Failed to create UIS container',
                e instanceof Error ? e : undefined
            );
            this.uisFailure = true;
        }
    }

    protected render() {
        if (this.uisFailure) {
            return html`<login-error></login-error>`;
        }
        return this.isUisEnabled ? nothing : html`<login-container></login-container>`;
    }

    public static get styles() {
        return [
            css`
                :host {
                    display: block;
                    height: 100%;
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: UisContainer;
    }
}
